import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
/** Reducers Import */
import DrawerReducer from '../Reducer/DrawerReducer';
import BottomSheetReducer from '../Reducer/BottomSheetReducer';
import WorkingCheckReducer from '../Reducer/WorkingCheckReducer';
import BaseInfoReducer from '../Reducer/BaseInfoReducer';
import SnackbarReducer from '../Reducer/SnackbarReducer';
import CommonReducer from '../Reducer/CommonReducer';
import InAppNotiReducer from '../Reducer/InAppNotiReducer';
import SystemBarReducer from '../Reducer/SystemBarReducer';
import SearchReducer from '../Reducer/SearchReducer';
import LoadingReducer from '../Reducer/LoadingReducer';
import CodeInfoReducer from '../Reducer/CodeInfoReducer';
import ErrorDialogReducer from '../Reducer/ErrorDialogReducer';
import NavBarInfoReducer from '../Reducer/NavBarInfoReducer';
import BackInfoReducer from '../Reducer/BackInfoReducer';
import HomeInfoReducer from '../Reducer/HomeInfoReducer';
import PermitReducer from '../Reducer/PermitReducer';
import TbmReducer from '../Reducer/TbmReducer';

const reducers = combineReducers({
  BaseInfo: BaseInfoReducer,
  drawers: DrawerReducer,
  bottomSheet: BottomSheetReducer,
  workingCheck: WorkingCheckReducer,
  snackbar: SnackbarReducer,
  common: CommonReducer,
  inAppNoti: InAppNotiReducer,
  systemBar: SystemBarReducer,
  searchInfo: SearchReducer,
  loading: LoadingReducer,
  code: CodeInfoReducer,
  errorDialog: ErrorDialogReducer,
  navBarInfo: NavBarInfoReducer,
  backInfo: BackInfoReducer,
  homeInfo: HomeInfoReducer,
  permit: PermitReducer,
  tbm: TbmReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['workingCheck', 'menus', 'BaseInfo', 'common', 'inAppNoti', 'code', 'backInfo', 'tbm'],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export default configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
